export const LOG_IN: string = "LOG_IN";
export const SIGN_UP: string = "SIGN_UP";
export const LOG_IN_SAGA: string = "LOG_IN_SAGA";
export const SIGN_UP_SAGA: string = "SIGN_UP_SAGA";
export const LOADED: string = "LOADED";
